var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExclamationMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_info-circle",
    "data-name": "vuesax/bold/info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10,0A10,10,0,1,0,20,10,10.016,10.016,0,0,0,10,0ZM9.25,6a.75.75,0,1,1,1.5,0v5a.75.75,0,0,1-1.5,0Zm1.67,8.38a1.032,1.032,0,0,1-.21.33,1.155,1.155,0,0,1-.33.21.942.942,0,0,1-.76,0,1.155,1.155,0,0,1-.33-.21,1.032,1.032,0,0,1-.21-.33.942.942,0,0,1,0-.76.9.9,0,0,1,.54-.54,1,1,0,0,1,.76,0,.9.9,0,0,1,.54.54.943.943,0,0,1,0,.76Z",
    transform: "translate(2 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(24 24) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationMark);
export default __webpack_public_path__ + "static/media/icon-exclamation-mark.eece8c708e5c3becb33d665e7c8026c8.svg";
export { ForwardRef as ReactComponent };